module.exports = __webpack_public_path__ + "static/logo-buddies.01c83c2b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/logo-buddies.svg
// module id = 527
// module chunks = 114276838955818